import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { IncidentDto } from '@shared/src/dtos/incident/IncidentDto';
import { IncidentStateDto } from '@shared/src/dtos/incident/IncidentStateDto';
import { IncidentsStructDto } from '@shared/src/dtos/incident/IncidentsStructDto';
import { IStandStillDto } from '@shared/src/dtos/incident/IStandStillDto';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { Observable } from 'rxjs';
import { BaseController } from '../base.controller';
import { RouteCMRAgents } from '../route/cmr/RouteCMRAgents';
import { SecurityController } from '../security/security.controller';

/**
 * Incidències dels agents externs (endpoints oberts). Equivalent a IncidentController de l'app
 */
@Injectable({
    providedIn: 'root',
})
export class OpenIncidentController extends BaseController {

    private base = '/public/incident';

    constructor(
        @Inject('SecurityController') protected securityController: SecurityController,
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router
    ) {
        super(http, alertService, translateService, loadingService, router);
    }

    /**
     * Des de la firma de la fase (phaseUUID) o des de la pantalla d'accions del QR de la ruta (uuidQR)
     */
    private getTargetBase(phaseUUID: string, uuidQR: string, agent: RouteCMRAgents): string {
        if (phaseUUID != null && phaseUUID.length > 0)
            return this.base + '/agentphase/' + agent + '/byphaseuuid/' + phaseUUID;
        return this.base + '/agent/' + agent + '/byuuid/' + uuidQR;
    }

    public getIncidentStruct(phaseUUID: string, uuidQR: string, agent: RouteCMRAgents): Observable<IncidentsStructDto> {
        return this.get(this.getTargetBase(phaseUUID, uuidQR, agent) + '/struct');
    }

    public getIncidentState(phaseUUID: string, uuidQR: string, agent: RouteCMRAgents): Observable<IncidentStateDto> {
        return this.get(this.getTargetBase(phaseUUID, uuidQR, agent) + '/state');
    }

    public reportIncident(phaseUUID: string, uuidQR: string, agent: RouteCMRAgents, incident: IncidentDto): Observable<boolean> {
        return this.postBusy(this.getTargetBase(phaseUUID, uuidQR, agent) + '/report', incident, 'reportIncident');
    }

    public reportIStandStill(phaseUUID: string, uuidQR: string, agent: RouteCMRAgents, standStill: IStandStillDto): Observable<boolean> {
        return this.postBusy(this.getTargetBase(phaseUUID, uuidQR, agent) + '/standstill/report', standStill, 'reportIStandStill');
    }

    public resolvedIStandStill(phaseUUID: string, uuidQR: string, agent: RouteCMRAgents): Observable<boolean> {
        return this.postBusy(this.getTargetBase(phaseUUID, uuidQR, agent) + '/standstill/resolved', null, 'resolvedIStandStill');
    }
}
